import { CheckMovement } from "../map/Movement";
import { Point } from "../../engine/space/bounds";
import {
  Directions,
  getDirectionTowards,
  getInDirection,
} from "../../engine/space/directions";
import { Actor, Encumbrance } from "../actors/Actor";
import { findActorForPosition, gameData } from "../GameManager";
import { GibManager } from "../anims/particleSystem";
import { FootstepParticle } from "../anims/particles/FootstepParticle";
import { getActorWeight, getWeightLevel, hasStrength } from "../items/formulas";
import EntityManager from "../EntityManager";
import {
  bestMoveTowardsPlayer,
  getAdjacentToPlayer,
} from "../actors/controllers/aiHelpers";
import { createDMap } from "../../lib/dMap";
import { moveIn } from "../map/Pathfinding";
import { attackTowards } from "./ActionAttacks";
import { getActiveAttack } from "../actors/weaponHelper";

export const wait = (actor: Actor) => {
  actor.status.waited = true;
  return { valid: true };
};

export const sprintTowards = (actor: Actor, options: { dir: Directions }) => {
  const weightLevel = getWeightLevel(
    getActorWeight(actor),
    actor.attributes.weight
  );

  if (weightLevel === Encumbrance.HEAVY) {
    return { valid: false };
  }

  actor.stamina.change(weightLevel === Encumbrance.LIGHT ? -15 : -30);
  moveTowards(actor, options);

  const { x, y } = getInDirection(actor, options.dir);
  if (findActorForPosition(x, y)) {
    if (weightLevel === Encumbrance.LIGHT) {
      const attack = getActiveAttack(actor);
      if (
        attack.stamina <= actor.stamina.current &&
        hasStrength(actor, attack)
      ) {
        attackTowards(actor, options);
      }
    }
  } else {
    moveTowards(actor, options);
  }
  actor.status.sprinted = true;

  return { valid: true };
};

export const moveTo = (actor: Actor, options: { target: Point }) => {
  const dir = getDirectionTowards(actor, options.target);
  return moveTowards(actor, { dir });
};

export const moveTowards = (actor: Actor, options: { dir: Directions }) => {
  const tile =
    gameData.current.tiles[actor.x + actor.y * gameData.current.width];
  if (!CheckMovement[options.dir](tile)) {
    return { valid: false };
  }
  const { x, y } = getInDirection(actor, options.dir);

  const playerWeight = getWeightLevel(
    getActorWeight(gameData.player),
    gameData.player.attributes.weight
  );

  if (playerWeight !== Encumbrance.LIGHT && actor !== gameData.player) {
    const [target, at] = bestMoveTowardsPlayer(actor);
    if (
      !actor.status.replanned &&
      gameData.player.status.moved &&
      at &&
      at === gameData.player
    ) {
      actor.status.replanned = true;
      EntityManager.actorReplan(actor);
      return { valid: true };
    }
  }

  if (!findActorForPosition(x, y)) {
    GibManager.runThenDestroy(FootstepParticle, actor.x, actor.y);
    actor.x = x;
    actor.y = y;
  }
  if (playerWeight !== Encumbrance.LIGHT && actor === gameData.player) {
    gameData.dMapPlayer = createDMap([actor], moveIn, 5); //Small dMap, only used for adjacency checks
  }
  actor.status.moved = true;
  return { valid: true };
};
